export const livingArray = [
    {id: "1", code: "LIVE_ALONE", detail: "Live alone"},
    {id: "2", code: "LIVE_PARENTS", detail: "Live with parents"},
    {id: "3", code: "LIVE_KIDS", detail: "Live with kids"},
    {id: "4", code: "LIVE_ROOMAMATES", detail: "Live with roomates"},
    {id: "5", code: "LIVE_PETS", detail: "Live with pets"}
  ];
  export const incomeArray = [
    {id: "1", code: "INC_LESS25", detail: "Less Than $25,000"},
    {id: "2", code: "INC_25TO35", detail: "$25,000 to $35,000"},
    {id: "3", code: "INC_35TO50", detail: "$35,000 to $50,000"},
    {id: "4", code: "INC_50TO80", detail: "$50,000 to $80,000"},
    {id: "5", code: "INC_80TO100", detail: "$80,000 to $100,000"},
    {id: "6", code: "INC_100TO125", detail: "$100,000 to $125,000"},
    {id: "7", code: "INC_125TO150", detail: "$125,000 to $150,000"},
    {id: "8", code: "INC_150TO199", detail: "$150,000 to $199,000"},
    {id: "9", code: "INC_200MORE", detail: "$200,000 to Unlimited"}
  ];
  export const drinkArray = [
    {id: "1", code: "DRINK_SOCIAL", detail: "Social"},
    {id: "2", code: "DRINK_DAILY", detail: "Daily"},
    {id: "3", code: "DRINK_NEVER", detail: "Never"}
  ];
  export const tobaccoArray = [
    {id: "1", code: "TOB_NEVER", detail: "Never"},
    {id: "2", code: "TOB_CIGAR", detail: "Cigar"},
    {id: "3", code: "TOB_DAILY", detail: "Daily"},
    {id: "4", code: "TOB_SOCIAL", detail: "Social"}
  ];
  export const employmentArray = [
    {id: "1", code: "EMP_FULLTIME", detail: "Fulltime"},
    {id: "2", code: "EMP_PARTTIME", detail: "Parttime"},
    {id: "3", code: "EMP_RETIRED", detail: "Retired"},
    {id: "4", code: "EMP_HOMEMAKER", detail: "Homemaker"},
    {id: "5", code: "EMP_STUDENT", detail: "Student"},
    {id: "6", code: "EMP_SELF", detail: "Self"},
    {id: "7", code: "EMP_UNEMPLOYED", detail: "Unemployed"}
  ];
  export const astroArray = [
    {id: "1", code: "SIGN_CAPRICORN", detail: "Capricorn"},
    {id: "2", code: "SIGN_AQUARIUS", detail: "Aquarius"},
    {id: "3", code: "SIGN_PISCES", detail: "Pisces"},
    {id: "4", code: "SIGN_AIRES", detail: "Aries"},
    {id: "5", code: "SIGN_TAURUS", detail: "Taurus"},
    {id: "6", code: "SIGN_GEMINI", detail: "Gemini"},
    {id: "7", code: "SIGN_CANCER", detail: "Cancer"},
    {id: "8", code: "SIGN_LEO", detail: "Leo"},
    {id: "9", code: "SIGN_VIRGO", detail: "Virgo"},
    {id: "10", code: "SIGN_LIBRA", detail: "Libra"},
    {id: "11", code: "SIGN_SCORPIO", detail: "Scorpio"},
    {id: "12", code: "SIGN_SAGITTARIUS", detail: "Sagittarius"}
  ];
  export const languagesArray = [
    {id: "1", code: "LANG_ENGLISH", detail: "English"},
    {id: "2", code: "LANG_FRENCH", detail: "French"},
    {id: "3", code: "LANG_GERMAN", detail: "German"},
    {id: "4", code: "LANG_ITALIAN", detail: "Italian"},
    {id: "5", code: "LANG_SPANISH", detail: "Spanish"},
    {id: "6", code: "LANG_DUTCH", detail: "Dutch"},
    {id: "7", code: "LANG_CHINESE", detail: "Chinese"},
    {id: "8", code: "LANG_JAPANESE", detail: "Japanese"},
    {id: "9", code: "LANG_RUSSIAN", detail: "Russian"},
    {id: "10", code: "LANG_HEBREW", detail: "Hebrew"},
    {id: "11", code: "LANG_ARABIC", detail: "Arabic"},
    {id: "12", code: "LANG_HINDI", detail: "Hindi"},
    {id: "13", code: "LANG_TAGALOG", detail: "Tagalog"},
    {id: "14", code: "LANG_URDU", detail: "Urdu"},
    {id: "15", code: "LANG_PORTUGUESE", detail: "Portuguese"}
  ];

  